<template></template>

<script>
import { logout } from "Adapters/ApiAdapter/user";
import { ROUTE_LOGIN } from "Consts/publicRoutes";

export default {
  name: "ForceLogoutCheck",
  data() {
    return {
      logoutTask: null,
      inactivityTime: 1200000,
    };
  },
  methods: {
    setUpLogoutCheck() {
      if (this.logoutTask) clearTimeout(this.logoutTask);
      this.logoutTask = setTimeout(async () => {
        await logout();
        await this.$router.push({
          name: ROUTE_LOGIN,
          params: { forcedLogout: true },
        });
      }, this.inactivityTime);
    },
  },
  created() {
    if (process.env.NODE_NEV === "production") {
      window.addEventListener("mousemove", this.setUpLogoutCheck);
      this.setUpLogoutCheck();
    }
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.setUpLogoutCheck);
    clearTimeout(this.logoutTask);
  },
};
</script>

<style scoped></style>
